import { StaticImage } from "gatsby-plugin-image"
import React, { useRef } from "react"
import { SlotType } from "../types/contentful.types"

export type SlotGamePopupType = {
  onCloseClick: () => any
  slot: SlotType | null
  onDownloadClick: () => void
}

const SlotGamePopup = ({
  slot,
  onCloseClick,
  onDownloadClick,
}: SlotGamePopupType) => {
  if (!slot) return null

  const iframeContainerRef = useRef<any>()
  const onFullscreenClick = () => {
    iframeContainerRef.current.classList.add("fullscreen")
  }

  const handleDownloadClick = () => {
    onCloseClick()
    onDownloadClick()
  }

  return (
    <div className='slot-game-popup-container top-0 left-0 fixed w-full h-full z-50 flex items-center justify-center'>
      <div className='popup-overlay'></div>
      <div ref={iframeContainerRef} className='slot-game-popup flex flex-col'>
        <button onClick={onCloseClick} className='slot-game-x'>
          X
        </button>
        <div className='flex slot-game-popup-top'>
          <div className='uppercase font-bold'>
            {slot.compose__page[0].title}
          </div>
          <div className='flex space-x-5 items-center'>
            {/* <div>
              <button>
                <StaticImage
                  src='../images/speaker.png'
                  alt='Close Popup'
                  width={30}
                />
              </button>
            </div> */}
            <div>
              <button onClick={onFullscreenClick}>
                <StaticImage
                  src='../images/full-screen.png'
                  alt='Close Popup'
                  width={30}
                />
              </button>
            </div>
            <button
              onClick={handleDownloadClick}
              className='glow-animation hero-cta-btn small-cta-btn'
            >
              get the app
            </button>
            <div>
              <button className='text-5xl font-bold' onClick={onCloseClick}>
                <StaticImage
                  src='../images/close-popup.png'
                  alt='Close Popup'
                  width={20}
                />
              </button>
            </div>
          </div>
        </div>
        <iframe
          src={slot.gameIframeUrl}
          className='w-full h-full'
          scrolling='no'
          allowFullScreen={true}
        />
      </div>
    </div>
  )
}

export default SlotGamePopup
